import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const navLinks = [
  { label: "기능 소개", href: "#features" },
  { label: "기업 유형", href: "#company-types" },
  { label: "교육 방식", href: "#how-it-works" },
  { label: "도입 문의", href: "#contact" },
];

export default function LandingNav() {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleAnchor = (href: string) => {
    setMobileOpen(false);
    if (href.startsWith("#")) {
      document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/95 backdrop-blur-md border-b border-black/[0.08] shadow-sm" : "bg-transparent"
      }`}
      style={{ fontFamily: "'Pretendard Variable', Pretendard, -apple-system, BlinkMacSystemFont, sans-serif" }}
    >
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        {/* Logo */}
        <h1 className="flex items-center gap-2.5 cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
          <img
            src="https://storage.readdy-site.link/project_files/e81f0f74-7f28-46c8-8485-3df778381a50/9a17726c-ea2b-4ef1-b154-44e1a8dd8821_Gemini_Generated_Image_at6qf4at6qf4at6q-removebg-preview.png?v=7e9fc5a9989fd2f2c3e90b758ae037ba"
            alt="K-ArtPEN 로고"
            className="w-8 h-8 object-contain shrink-0"
          />
          <span className={`font-semibold text-base transition-colors ${scrolled ? "text-[#111111]" : "text-white"}`}>K-ArtPEN</span>
        </h1>

        {/* Desktop Nav */}
        <ul className="hidden md:flex items-center gap-7">
          {navLinks.map((link) => (
            <li key={link.label}>
              <a
                href={link.href}
                onClick={(e) => { e.preventDefault(); handleAnchor(link.href); }}
                className={`text-sm transition-colors cursor-pointer ${
                  scrolled ? "text-[#888888] hover:text-[#111111]" : "text-white/70 hover:text-white"
                }`}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        {/* CTA Buttons */}
        <div className="hidden md:flex items-center gap-3">
          <button
            type="button"
            onClick={() => navigate("/login")}
            className={`text-sm px-4 py-2 transition-colors cursor-pointer whitespace-nowrap ${
              scrolled ? "text-[#888888] hover:text-[#111111]" : "text-white/70 hover:text-white"
            }`}
          >
            로그인
          </button>
          <button
            type="button"
            onClick={() => handleAnchor("#contact")}
            className="bg-[#4B6CF7] hover:bg-[#5B7CF7] text-white text-sm px-5 py-2 rounded-lg transition-colors cursor-pointer whitespace-nowrap font-medium"
          >
            도입 문의
          </button>
        </div>

        {/* Mobile Menu Button */}
        <button
          type="button"
          className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${scrolled ? "text-[#666666]" : "text-white/80"}`}
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          <i className={`${mobileOpen ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-white/98 border-t border-black/[0.07] px-6 py-4 space-y-3">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => { e.preventDefault(); handleAnchor(link.href); }}
              className="block text-[#666666] hover:text-[#111111] text-sm py-2 transition-colors cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <div className="pt-2 flex flex-col gap-2">
            <button type="button" onClick={() => navigate("/login")} className="w-full text-[#666666] text-sm py-2 border border-black/[0.09] rounded-lg cursor-pointer whitespace-nowrap hover:bg-black/[0.02]">로그인</button>
            <button type="button" onClick={() => handleAnchor("#contact")} className="w-full bg-[#4B6CF7] text-white text-sm py-2 rounded-lg cursor-pointer whitespace-nowrap font-medium hover:bg-[#5B7CF7]">도입 문의</button>
          </div>
        </div>
      )}
    </nav>
  );
}
